import React from "react";
import style from "./index.module.scss";
import { Col, Row } from "antd";
import { StuReadItem } from "../../../../../service/notice";
import Empty from "./components/Empty";

interface ReadListProps {
    data: StuReadItem[];
    emptyTip: string;
}

export default function ReadList({ data, emptyTip }: ReadListProps) {
    return (
        <div className={style.root}>
            {data.map(item => (
                <Row className={style.item} key={item.studentId}>
                    <Col
                        span={12}
                        className={style.stuName}
                        title={item.studentName}>
                        {item.studentName}
                    </Col>

                    <Col
                        span={12}
                        className={style.stuId}
                        title={item.studentId}>
                        {item.studentId}
                    </Col>
                </Row>
            ))}

            {data.length === 0 && <Empty tip={emptyTip} />}
        </div>
    );
}
